import Keycloak from "keycloak-js";

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_REALM,
  clientId: process.env.REACT_APP_CLIENT_ID
};

if (!keycloakConfig.url || !keycloakConfig.realm || !keycloakConfig.clientId) {
  throw new Error('Keycloak configuration is incomplete. Please check your environment variables.');
}

const keycloak = new Keycloak(keycloakConfig);

keycloak.onAuthError = (error) => {
  console.error('Keycloak authentication error:', error);
};

keycloak.onAuthRefreshError = () => {
  console.log('Token refresh failed, redirecting to login');
  keycloak.logout({ redirectUri: window.location.origin });
};

keycloak.onTokenExpired = () => {
  keycloak.updateToken(30).catch((error) => {
    console.error('Failed to refresh expired token:', error);
    keycloak.logout({ redirectUri: window.location.origin });
  });
};

const initOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  flow: 'standard'
};

export { keycloak, initOptions };
